// extracted by mini-css-extract-plugin
module.exports = {"enabled":"Switch-module__enabled--1C6Aj","disabled":"Switch-module__disabled--vsTpz"};